import React from 'react'
import { useLocation } from 'react-router-dom'
import { getModerationHorsesCount } from 'store/horses'
import { getPendingReviewsCount } from 'store/reviews'
import { getPendingWithdrawalRequests } from 'store/withdrawalRequests'
import { useAppDispatch } from './useReduxHooks'

// Счётчики бейджей меню: раздел «Действия» и лошади на модерации. Хук зовём из шапки:
// она смонтирована всегда, поэтому числа обновляются на каждом переходе, где бы админ ни находился
export const useActionsCounters = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()

  React.useEffect(() => {
    dispatch(getModerationHorsesCount())
    dispatch(getPendingReviewsCount())
    dispatch(getPendingWithdrawalRequests())
  }, [location.pathname])
}
